import { createFileRoute } from "@tanstack/react-router";
import { Spinner } from "@timeghost/ui/shadcn/spinner";
import { type JSX, lazy, Suspense } from "react";

const TestingPage = lazy(() => import("@/components/testing/testing-page"));

const TestingRoute = (): JSX.Element => (
	<Suspense fallback={<Spinner className="m-6" />}>
		<TestingPage />
	</Suspense>
);

export const Route = createFileRoute("/_app/testing/")({
	component: TestingRoute,
});
